<script>
    import { store, store_offer } from '../../Store.svelte';
    import { env } from '../../Environment.svelte';
    import { fetchOffer } from '../../clients/OfferClient.svelte';
    import {
        fetchMunicipality,
        fetchAddresses,
        fetchOffNet,
    } from '../../clients/AddressesClient.svelte';
    import { getToken } from '../../Util.svelte';
    import Button from '../../components/Button.svelte';
    import Preloader from '../Preloader.svelte';
    import { tick } from 'svelte';

    export let home = false;
    export let locationPath;

    let buttonDisabled = true;
    let isLoading = false;
    let postalCode = '';
    let addressRPT = '';
    $: municipality = '';
    $: coverageError = false;

    let validatePostalCode = async () => {
        coverageError = false;

        if (postalCode.length == 5) {
            isLoading = true;
            try {
                let result = await fetchMunicipality(postalCode);
                municipality = result.municipality;
                addressQuery = '';
                if (municipality != null && municipality != '') {
                    $store.requestedAddress.offnetCoverage = false;
                    coverageError = false;
                } else if (locationPath == 'residencial' || home) {
                    result = await fetchOffNet(postalCode);
                    if (result != null && result != '') {
                        municipality = result;
                        $store.requestedAddress.offnetCoverage = true;
                        buttonDisabled = false;
                        coverageError = false;
                    } else {
                        buttonDisabled = true;
                        coverageError = true;
                    }
                } else {
                    buttonDisabled = true;
                    coverageError = true;
                }
            } catch (error) {
                buttonDisabled = true;
                coverageError = true;
            } finally {
                $store.requestedAddress.municipality = municipality;
                isLoading = false;
            }
        } else {
            municipality = '';
        }
    };

    let lastKeystroke = new Date();
    let addressQuery = '';
    $: addresses = [];
    let validateAddressQuery = () => {
        if (addressQuery.length > 4) {
            lastKeystroke = new Date();
            setTimeout(function () {
                searchAddress();
            }, 800);
            buttonDisabled = false;
        } else {
            addresses = [];
            buttonDisabled = true;
        }
    };

    $: searchAddress = () => {
        var dif = new Date() - lastKeystroke;
        if (dif > 750) {
            buttonDisabled = true;
            fetchAddresses(postalCode, addressQuery)
                .then((result) => {
                    buttonDisabled = false;
                    if (result.addresses != null) {
                        addresses = result.addresses;
                    } else {
                        addresses = [];
                    }
                })
                .catch(() => {
                    buttonDisabled = true;
                });
        }
    };

    let selectAddress = (
        addressId,
        addressString,
        rpt,
        calle,
        colonia,
        delegacion,
        estado,
        numero,
        interior,
        latitud,
        longitud
    ) => {
        addresses = [];
        addressQuery = addressString;
        addressRPT = rpt;
        checkCoverage(
            addressId,
            addressString,
            calle,
            colonia,
            delegacion,
            estado,
            numero,
            interior,
            latitud,
            longitud
        );
    };

    const checkCoverage = (
        addressId = '',
        addressString = addressQuery,
        calle = '',
        colonia = '',
        delegacion = '',
        estado = '',
        numero = '',
        interior = '',
        latitud = '',
        longitud = ''
    ) => {
        isLoading = true;
        buttonDisabled = true;

        if ($store.requestedAddress.offnetCoverage) {
            $store.requestedAddress.postalCode = postalCode;
        }

        fetchOffer(
            postalCode,
            addressId,
            $store.requestedAddress.offnetCoverage
        ).then((result) => {
            isLoading = false;
            if (!result) {
                checkCoverage(addressId, addressString);
                return;
            }
            buttonDisabled = false;
            if (result.coverage) {
                handleCoverageFound(
                    addressId,
                    addressString,
                    calle,
                    colonia,
                    delegacion,
                    estado,
                    numero,
                    interior,
                    latitud,
                    longitud,
                    result
                );
            } else {
                coverageError = true;
            }
        });
    };

    const handleCoverageFound = (
        addressId,
        addressString,
        calle,
        colonia,
        delegacion,
        estado,
        numero,
        interior,
        latitud,
        longitud,
        result
    ) => {
        let token;
        if (home) {
            if ($store.requestedAddress.offnetCoverage) {
                token = getToken(
                    $store.requestedAddress.postalCode,
                    $store.requestedAddress.offnetCoverage,
                    $store.requestedServices.isSky
                );
            } else {
                token = getToken(
                    postalCode,
                    $store.requestedAddress.offnetCoverage,
                    $store.requestedServices.isSky,
                    addressString,
                    addressId,
                    $store.requestedServices.productObject,
                    addressRPT,
                    calle,
                    colonia,
                    delegacion,
                    estado,
                    numero,
                    interior,
                    latitud,
                    longitud
                );
            }
            window.parent.location = `${env[env.stage].urlweb}/receiver/purchase-sky/${token}`;
        } else {
            updateStoreAddress(
                addressId,
                addressString,
                calle,
                colonia,
                delegacion,
                estado,
                numero,
                interior,
                latitud,
                longitud,
                result
            );
            reloadPageAfterModal();
        }
    };

    const updateStoreAddress = (
        addressId,
        addressString,
        calle,
        colonia,
        delegacion,
        estado,
        numero,
        interior,
        latitud,
        longitud,
        result
    ) => {
        $store.requestedAddress = {
            ...$store.requestedAddress,
            addressId,
            postalCode,
            addressString,
            addressRPT,
            street: calle ?? '',
            suburb: colonia ?? '',
            city: delegacion ?? '',
            state: estado ?? '',
            externalNumber: numero ?? '',
            internalNumber: interior ?? '',
            longitude: longitud ?? '',
            latitude: latitud ?? '',
        };
        $store.purchaseStatus = env.cleanstore.purchaseStatus;
        $store.requestedServices = env.cleanstore.requestedServices;
        store_offer.set(env.cleanstore_offer);
        store_offer.set({
            dateLoaded: new Date(),
            loadedOffer: result,
        });
    };

    const reloadPageAfterModal = () => {
        setTimeout(() => {
            MicroModal.close('modal-cobertura');
            activateOffers();
            location.reload();
        }, 150);
    };

    const openMiniWindow = (url) => {
        window.open(url, '_blank', 'width=600,height=400');
    };

    const displayAddressSelector = async () => {
        postalCode = '';
        validatePostalCode();
        await tick();
        inputsHandler();
    };
</script>

<div class="modal__overlay" tabindex="-1" data-micromodal-close>
    <div
        class="modal__container modal__container--extra-large"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-sencilla-title"
    >
        <div class="modal__header" role="banner">
            <div>
                <h2
                    class="modal__title fw-semibold text-fs-20"
                    id="modal-sencilla-title"
                >
                    {coverageError
                        ? '¡exploremos otras opciones!'
                        : 'verifiquemos la cobertura en tu localidad'}
                </h2>
                <h2 class="modal__title text-fs-15" id="modal-sencilla-title">
                    {coverageError
                        ? 'No logramos encontrar ofertas debido a la falla de cobertura, para mas  información inicia un chat con izzi'
                        : 'estamos a un paso de mostrarte paquetes que te harán saltar de la emoción'}
                </h2>
            </div>
            <button
                class="modal__close"
                aria-label="Close modal"
                data-micromodal-close
            ></button>
        </div>
        {#if !coverageError}
            <div class="modal__content" id="modal-1-content" role="main">
                <div class="align-items-center m-b-20">
                    <div
                        class="d-flex align-items-start justify-content-start gap-3 sm-zip-code"
                    >
                        <div class="pure-u-1 pure-u-md-1-2">
                            <div class="ctrl-holder sm-m-b-20">
                                <label for="codigoPostal" class="placeholder"
                                    >Código postal</label
                                >
                                <input
                                    type="text"
                                    name="codigoPostal"
                                    id="codigoPostal"
                                    required
                                    maxlength="5"
                                    on:keyup={validatePostalCode}
                                    bind:value={postalCode}
                                />
                            </div>
                        </div>
                        <div>
                            <p class="fw-semibold m-b-5">Ciudad</p>
                            <p class="m-b-0">
                                {municipality || 'Ingresa tu código postal'}
                            </p>
                        </div>
                    </div>
                </div>
                {#if municipality && !$store.requestedAddress.offnetCoverage}
                    <div class="pure-g">
                        <div class="pure-u-1">
                            <div class="ctrl-holder focused">
                                <label for="direccion" class="placeholder"
                                    >Dirección</label
                                >
                                <input
                                    type="text"
                                    name="direccion"
                                    id="direccion"
                                    required
                                    autocomplete="off"
                                    on:keyup={validateAddressQuery}
                                    bind:value={addressQuery}
                                />
                                {#if addresses.length > 0}
                                    <ul class="suggestions-list">
                                        {#each addresses as address}
                                            <li
                                                value={address.id}
                                                on:click={() =>
                                                    selectAddress(
                                                        address.id,
                                                        address.label,
                                                        address.rpt,
                                                        address.calle,
                                                        address.colonia,
                                                        address.delegacion,
                                                        address.estado,
                                                        address.numero,
                                                        address.interior,
                                                        address.latitud,
                                                        address.longitud
                                                    )}
                                                on:keydown={() =>
                                                    selectAddress(
                                                        address.id,
                                                        address.label,
                                                        address.rpt,
                                                        address.calle,
                                                        address.colonia,
                                                        address.delegacion,
                                                        address.estado,
                                                        address.numero,
                                                        address.interior,
                                                        address.latitud,
                                                        address.longitud
                                                    )}
                                            >
                                                {address.label}
                                            </li>
                                        {/each}
                                    </ul>
                                {/if}
                            </div>
                        </div>
                    </div>
                {/if}
                {#if isLoading}
                    <div class="text-center" style="height: 2em;">
                        <Preloader />
                    </div>
                {/if}
            </div>
        {/if}
        <div class="modal__footer" role="contentinfo">
            {#if !coverageError}
                <div
                    class="d-flex align-items-center justify-content-between sm-alet-button"
                >
                    <p
                        class="small m-b-0 flex-grow-1 flex-shrink-1 suggestion-text text-left m-r-5"
                    >
                        <img
                            src="/assets/img/icons/info.png"
                            class="icon-info"
                            alt="alert"
                        />
                        <span class="fw-semibold">Nota:</span> Selecciona tu calle
                        en el menú desplegable. Si no la encuentras, ingrésala completa
                        y haz clic en verificar cobertura.
                    </p>
                    <div>
                        <Button
                            variant={$store.requestedServices.isSky
                                ? 'pure__button--blue-dark'
                                : 'pure__button--base'}
                            label="verificar cobertura"
                            process="verificar cobertura"
                            disabled={buttonDisabled}
                            onClick={checkCoverage}
                        />
                    </div>
                </div>
            {/if}
            {#if coverageError}
                <div
                    class="d-flex align-items-end justify-content-end gap-1 m-t-20 sm-coverage-buttons"
                >
                    <Button
                        variant={$store.requestedServices.isSky
                            ? 'pure__button--blue-dark'
                            : 'pure__button--white'}
                        label="ingresa otra dirección"
                        process="ingresa otra dirección"
                        onClick={displayAddressSelector}
                    />
                    <div>
                        <Button
                            variant={$store.requestedServices.isSky
                                ? 'pure__button--blue-dark'
                                : 'pure__button--base'}
                            label="iniciar chat con izzi"
                            process="iniciar chat con izzi"
                            onClick={() =>
                                openMiniWindow(
                                    `${env[env.stage].urlIzziWeb}/webApps/chat?cpgid=468341&fromlanding=true`
                                )}
                        />
                    </div>
                </div>
            {/if}
        </div>
    </div>
</div>
